export const FB_PIXEL_ID = '1180941288654590';

export const pageview = () => {
  if (window.fbq) {
    window.fbq('track', 'PageView');
  }
};

// https://developers.facebook.com/docs/facebook-pixel/advanced/
export const event = (name, options = {}) => {
  if (window.fbq) {
    window.fbq('track', name, options);
  }
}; 